export default __webpack_public_path__ + "static/media/keyvisual_contact.7aebfca9.jpg";